import React, { useState, useMemo, useEffect } from "react";
import {
  Box,
  Grid,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Heading,
  useToast,
  Flex,
  Spinner,
  Center,
  useBreakpointValue,
  Button,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import { useNavigate, useLocation } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { FormHeader } from "../../../ui/FormHeader";
import { getProduct } from "../../../redux/reduxApi/admin/ProductReduxApi";
import { addBom, updateBom, getBomById } from "../../../redux/api/admin/BomApi"; // Add getBomById import
import { useDispatch, useSelector } from "react-redux";
import { getRawMaterialList } from "../../../redux/reduxApi/admin/RawMaterialApi";
import { getEmployeesList } from "../../../redux/reduxApi/admin/EmployeesReduxApi";
import { getColoursList } from "../../../redux/reduxApi/admin/ColourReduxApi";
import { getLoggedInUserId } from "../../../../utils/authUtils";
import { getUserDetails } from "../../../../utils/IndexDB/PermissionStore";
import { formatDateTime } from "../../../../utils/commonFunctions";

export default function BOMForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const loggedInUserId = getLoggedInUserId();
  const [userDetails, setUserDetails] = useState(null);
  const [createdByOptions, setCreatedByOptions] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fetchingBom, setFetchingBom] = useState(false);
  const spacing = useBreakpointValue({ base: 3, md: 4 });
  const dispatch = useDispatch();
  const bomId = location.pathname.split("/").pop();
  const isEditMode =
    location.pathname.includes("update-bom-form") ||
    location.pathname.includes("edit") ||
    (bomId && bomId !== "bom-form");
  const getInventory = useSelector((state) => state?.inventory?.inventory);
  const getRawMaterial = useSelector((state) => state?.rawMaterial?.rawMaterial);
  const inventoryStatus = useSelector((state) => state?.inventory?.status);
  const inventoryError = useSelector((state) => state?.inventory?.error);

  const [productList, setProductList] = useState([]);
  const [finishedGoodsList, setFinishedGoodsList] = useState([]);
  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [colourOptions, setColourOptions] = useState([]);
  console.log("raw material listtttttttttttttttttt", rawMaterialList)
  const [bomData, setBomData] = useState(null);
  console.log("bom data", bomData)
  const [deletedItems, setDeletedItems] = useState([]);

  const getEmployeeIdValue = (value) => {
    if (!value) return null;
    if (typeof value === "object") {
      return value.ROWID || value.id || null;
    }
    return String(value);
  };

  const getColourValue = (value) => {
    if (!value) return null;
    if (typeof value === "object") {
      return value.ROWID || value.value || null;
    }
    return String(value);
  };

  const resolveEmployeeObject = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;
    return employeesList.find((e) => String(e.ROWID) === String(value)) || null;
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      const user = await getUserDetails();
      setUserDetails(user);
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    dispatch(getEmployeesList({ page: 1, size: 30, limit: 30 }))
      .then((response) => {
        const employees = response.payload?.data?.employees || [];
        const options = employees.map((emp) => ({
          label: `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.email || emp.employeeName || "Unknown",
          value: emp.ROWID,
        }));
        setCreatedByOptions(options);
        setEmployeesList(employees);
      })
      .catch((error) => {
        console.error("Error fetching employees for BOM audit fields:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getColoursList())
      .then((response) => {
        const colours = response?.payload?.data?.colours || [];
        const options = colours.map((colour) => ({
          value: colour.ROWID,
          label: colour.colour || colour.name || "Unknown",
        }));
        setColourOptions(options);
      })
      .catch((error) => {
        console.error("Error fetching colours for BOM form:", error);
      });
  }, [dispatch]);

  // If employees load after bomData, ensure bomForm has the detail objects for display
  useEffect(() => {
    if (!bomData || !employeesList || employeesList.length === 0) return;

    setBomForm((prev) => {
      // don't overwrite if details already present
      const creatorId = prev.createdBy || bomData.createdBy || bomData.CREATORID || bomData.creatorId || null;
      const modifierId = prev.modifiedBy || bomData.modifiedBy || bomData.MODIFIERID || bomData.modifierId || null;

      const newCreatedDetails = prev.createdByDetails || employeesList.find((e) => String(e.ROWID) === String(creatorId)) || bomData.createdByDetails || null;
      const newModifiedDetails = prev.modifiedByDetails || employeesList.find((e) => String(e.ROWID) === String(modifierId)) || bomData.modifiedByDetails || null;

      if (newCreatedDetails === prev.createdByDetails && newModifiedDetails === prev.modifiedByDetails) return prev;

      return {
        ...prev,
        createdByDetails: newCreatedDetails,
        modifiedByDetails: newModifiedDetails,
      };
    });
  }, [employeesList, bomData]);

  useEffect(() => {
    if (productList && productList.length > 0) {
      // const finished = productList.filter(
      //   (item) => item.type === "Finished Goods",
      // );
      setFinishedGoodsList(productList);
      // const raw = productList.filter((item) => item.type === "Raw Material");
      // const rawWithImages = raw.map((product) => ({
      //   ...product,
      //   imageUrl: parseImageUrl(product.itemImages),
      // }));

      // setRawMaterialList(rawWithImages);
      // console.log("Raw Materials with images:", rawWithImages);
    }
  }, [productList]);

  const finishedGoodsOptions = useMemo(() => {
    return finishedGoodsList.map((product) => ({
      value: product.ROWID,
      label: `${product.itemName}`,
      product: product,
    }));
  }, [finishedGoodsList]);

  // const parseImageUrl = (itemImages) => {
  //   if (!itemImages) return "";

  //   try {
  //     if (typeof itemImages === "object") {
  //       if (Array.isArray(itemImages) && itemImages.length > 0) {
  //         return itemImages[0]?.filePath || itemImages[0]?.url || "";
  //       } else if (itemImages.filePath) {
  //         return itemImages.filePath;
  //       } else if (itemImages.url) {
  //         return itemImages.url;
  //       }
  //     }

  //     if (typeof itemImages === "string") {
  //       // Try to parse JSON string
  //       if (itemImages.startsWith("[") || itemImages.startsWith("{")) {
  //         const parsed = JSON.parse(itemImages);
  //         if (Array.isArray(parsed) && parsed.length > 0) {
  //           return parsed[0]?.filePath || parsed[0]?.url || "";
  //         } else if (parsed.filePath) {
  //           return parsed.filePath;
  //         } else if (parsed.url) {
  //           return parsed.url;
  //         }
  //       }

  //       if (itemImages.startsWith("http")) {
  //         return itemImages;
  //       }
  //     }

  //     return "";
  //   } catch (error) {
  //     console.error("Error parsing image:", error, "for value:", itemImages);
  //     return "";
  //   }
  // };

  const parseImageUrl = (itemImages) => {
    if (!itemImages) return "";
    console.log("items itmage", itemImages)
    try {
      let url = "";

      // ✅ Case 1: already object
      if (typeof itemImages === "object") {
        if (Array.isArray(itemImages) && itemImages.length > 0) {
          url = itemImages[0]?.filePath || itemImages[0]?.url || "";
        } else if (itemImages.filePath) {
          url = itemImages.filePath;
        } else if (itemImages.url) {
          url = itemImages.url;
        }
      }

      // ✅ Case 2: string
      else if (typeof itemImages === "string") {
        if (itemImages.startsWith("[") || itemImages.startsWith("{")) {
          const parsed = JSON.parse(itemImages);
          console.log("parsed image data", parsed)
          if (Array.isArray(parsed) && parsed.length > 0) {
            url = parsed[0] || parsed[0]?.url || "";
          } else if (parsed.filePath) {
            url = parsed.filePath;
          } else if (parsed[0]) {
            url = parsed[0];
          }
        } else if (itemImages.startsWith("http")) {
          url = itemImages;
        }
        console.log("extracted url", url)

      }
      // 🔥 IMPORTANT FIX → encode URL
      return encodeURI(url);

    } catch (error) {
      console.error("Error parsing image:", error, "for value:", itemImages);
      return "";
    }

  };

  const rawMaterialOptions = useMemo(() => {
    return rawMaterialList?.map((product) => ({
      value: product.ROWID,
      label: `${product.productName}`,
      // product: product,
      unit: product.consumptionUnit || "pcs",
      availableStock: product.availableStock || 0,
      imageUrl: parseImageUrl(product.img),
    }));
  }, [rawMaterialList]);
  console.log("raw material options", rawMaterialOptions)

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        await dispatch(getProduct({ limit: 100 })).unwrap();
      } catch (error) {
        console.error("Error fetching Raw Material data:", error);
        toast({
          title: "Error",
          description: error || "Failed to fetch Raw Materail",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };


    fetchProducts();
  }, [dispatch, toast]);

  useEffect(() => {
    const fetchRawMaterial = async () => {
      try {
        setLoading(true);
        await dispatch(getRawMaterialList({ limit: 100 })).unwrap();
      } catch (error) {
        console.error("Error fetching Raw Material data:", error);
        toast({
          title: "Error",
          description: error || "Failed to fetch Raw Material",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchRawMaterial();
  }, [dispatch, toast]);

  useEffect(() => {
    if (getInventory && getInventory.length > 0) {
      setProductList(getInventory);
    }
  }, [getInventory]);
  useEffect(() => {
    if (getRawMaterial && getRawMaterial.length > 0) {
      setRawMaterialList(getRawMaterial);
    }
  }, [getRawMaterial]);

  useEffect(() => {
    const fetchBomData = async () => {
      if (isEditMode && bomId && bomId !== "bom-form") {
        try {
          setFetchingBom(true);
          const response = await getBomById(bomId);
          const fetchedBomData = response.data?.data;
          if (fetchedBomData) {
            const transformedData = {
              ...fetchedBomData.bomMaster,
              bomItems: fetchedBomData.bomItem || [],
            };
            setBomData(transformedData);
          } else {
            toast({
              title: "Error",
              description: "No BOM data found",
              status: "error",
              duration: 5000,
            });
          }
        } catch (error) {
          console.error("Error fetching BOM:", error);
          toast({
            title: "Error",
            description:
              error.response?.data?.message || "Failed to fetch BOM data",
            status: "error",
            duration: 5000,
          });
        } finally {
          setFetchingBom(false);
        }
      }
    };

    if (isEditMode && bomId && bomId !== "bom-form") {
      fetchBomData();
    }
  }, [isEditMode, bomId, toast]);

  useEffect(() => {
    if (
      isEditMode &&
      bomData &&
      finishedGoodsList.length > 0 &&
      rawMaterialList.length > 0
    ) {
      const finishedGood = finishedGoodsList.find(
        (p) => p.ROWID === bomData.item,
      );

      const resolveEmployeeObject = (value) => {
        if (!value) return null;
        if (typeof value === "object") return value;
        return employeesList.find((e) => String(e.ROWID) === String(value)) || null;
      };

      const creatorDetails =
        resolveEmployeeObject(bomData.createdBy) ||
        bomData.createdByDetails ||
        null;
      const modifierDetails =
        resolveEmployeeObject(bomData.modifiedBy) ||
        bomData.modifiedByDetails ||
        null;

      const creatorId =
        getEmployeeIdValue(creatorDetails) ||
        getEmployeeIdValue(bomData.createdBy) ||
        bomData.createdById ||
        bomData.CREATORID ||
        bomData.creatorId ||
        null;
      const modifierId =
        getEmployeeIdValue(modifierDetails) ||
        getEmployeeIdValue(bomData.modifiedBy) ||
        bomData.modifiedById ||
        bomData.MODIFIERID ||
        bomData.modifierId ||
        null;

      const colourValue =
        bomData.colour?.ROWID ||
        bomData.colour?.value ||
        bomData.colour ||
        null;
      const selectedColour = colourValue
        ? colourOptions.find((opt) => String(opt.value) === String(colourValue)) || {
            value: colourValue,
            label: bomData.colour?.colour || bomData.colour?.label || colourValue,
          }
        : null;

      setBomForm({
        bom: bomData.bom || "",
        item: finishedGood
          ? {
            value: finishedGood.ROWID,
            label: finishedGood.itemName,
            product: finishedGood,
          }
          : null,
        colour: selectedColour,
        version: bomData.version || "",
        description: bomData.description || "",
        createdBy: creatorId ? String(creatorId) : null,
        modifiedBy: modifierId ? String(modifierId) : null,
        createdByDetails: creatorDetails,
        modifiedByDetails: modifierDetails,
        CREATEDTIME: bomData.CREATEDTIME || bomData.createdTime || bomData.createdAt || "",
        MODIFIEDTIME: bomData.MODIFIEDTIME || bomData.modifiedTime || bomData.updatedAt || "",
      });

      if (bomData.bomItems && bomData.bomItems.length > 0) {
        const initialRows = bomData.bomItems.map((material, index) => {
          const rawMaterial = rawMaterialList.find(
            (p) => p.ROWID === material.productId,
          );
          return {
            id: Date.now() + index,
            ROWID: material.ROWID,
            sno: index + 1,
            item: rawMaterial
              ? {
                value: rawMaterial.ROWID,
                label: rawMaterial.productName,
                unit: rawMaterial.consumptionUnit || "pcs",
                availableStock: rawMaterial.availableStock || 0,
                imageUrl: parseImageUrl(rawMaterial.img),
              }
              : null,
            itemData: rawMaterial || null,
            uom: material.uom || rawMaterial?.consumptionUnit || "",
            consumptionQuantity: material.consumptionQuantity?.toString() || "",
            availableQuantity:
              material.availableQuantity?.toString() ||
              rawMaterial?.availableStock?.toString() ||
              "",
          };
        });
        setRows(initialRows);
      }
    }
  }, [isEditMode, bomData, finishedGoodsList, rawMaterialList, colourOptions]);

  const [rows, setRows] = useState([
    {
      id: Date.now(),
      sno: 1,
      item: null,
      itemData: null,
      uom: "",
      consumptionQuantity: "",
      availableQuantity: "",
    },
  ]);

  console.log("selected raw material rows", rows)

  const [bomForm, setBomForm] = useState({
    bom: "",
    item: null,
    colour: null,
    version: "",
    description: "",
    createdBy: loggedInUserId ? String(loggedInUserId) : null,
    modifiedBy: null,
    createdByDetails: null,
    modifiedByDetails: null,
    CREATEDTIME: "",
    MODIFIEDTIME: "",
  });

  const loggedInUserOption = useMemo(() => {
    if (!loggedInUserId) return null;

    return {
      label: userDetails?.employeeName || "Current User",
      value: loggedInUserId,
    };
  }, [loggedInUserId, userDetails]);

  const selectedCreatedByOption = useMemo(() => {
    const targetCreatedBy = bomForm.createdBy;
    if (!targetCreatedBy) return null;

    const option = createdByOptions.find(
      (opt) => String(opt.value) === String(targetCreatedBy)
    );
    if (option) return option;

    if (bomForm.createdByDetails) {
      const details = bomForm.createdByDetails;
      const fullName = `${details.firstName || ""} ${details.lastName || ""}`.trim();
      return {
        label: fullName || details.employeeName || details.email || "Unknown",
        value: details.ROWID || targetCreatedBy,
      };
    }

    if (loggedInUserOption && String(loggedInUserOption.value) === String(targetCreatedBy)) {
      return loggedInUserOption;
    }

    if (typeof targetCreatedBy === "string" && !/^\d+$/.test(targetCreatedBy)) {
      return { label: targetCreatedBy, value: targetCreatedBy };
    }
      
    return null;
  }, [createdByOptions, bomForm.createdBy, bomForm.createdByDetails, loggedInUserOption]);

  const selectedModifiedByOption = useMemo(() => {
    const targetModifiedBy = bomForm.modifiedBy;

    if (targetModifiedBy) {
      const option = createdByOptions.find(
        (opt) => String(opt.value) === String(targetModifiedBy)
      );
      if (option) return option;

      if (loggedInUserOption && String(loggedInUserOption.value) === String(targetModifiedBy)) {
        return loggedInUserOption;
      }

      if (bomForm.modifiedByDetails) {
        const details = bomForm.modifiedByDetails;
        const fullName = `${details.firstName || ""} ${details.lastName || ""}`.trim();
        return {
          label: fullName || details.employeeName || details.email || "Unknown",
          value: details.ROWID || targetModifiedBy,
        };
      }

      if (typeof targetModifiedBy === "string" && !/^\d+$/.test(targetModifiedBy)) {
        return { label: targetModifiedBy, value: targetModifiedBy };
      }
    }

    return null;
  }, [createdByOptions, bomForm.modifiedBy, bomForm.modifiedByDetails, loggedInUserOption]);

  const addRow = () => {
    setRows((prev) => [
      ...prev,
      {
        id: Date.now(),
        sno: prev.length + 1,
        item: null,
        itemData: null,
        uom: "",
        consumptionQuantity: "",
        availableQuantity: "",
      },
    ]);
  };

  const deleteRow = (id) => {
    const row = rows.find((r) => r.id === id);

    if (row?.ROWID) {
      setDeletedItems((prev) => [
        ...prev,
        { ROWID: row.ROWID }
      ]);
    }

    setRows((prev) => prev.filter((r) => r.id !== id));
  };

  const handleItemChange = (selectedOption, rowId) => {
    console.log("Selected Option:", selectedOption);
    setRows((prev) =>
      prev.map((row) => {
        if (row.id === rowId) {
          return {
            ...row,
            item: selectedOption,
            itemData: selectedOption || null,
            uom: selectedOption?.consumptionUnit || "",
            availableQuantity: selectedOption?.availableStock?.toString() || "",
          };
        }
        return row;
      }),
    );
  };

  const handleUOMChange = (rowId, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.id === rowId) {
          return {
            ...row,
            uom: value,
          };
        }
        return row;
      }),
    );
  };

  const handleConsumptionQuantityChange = (rowId, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.id === rowId) {
          return {
            ...row,
            consumptionQuantity: value,
          };
        }
        return row;
      }),
    );
  };

  const handleBomFormChange = (field, value) => {
    setBomForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Validate form before submission
  const validateForm = () => {
    const newErrors = {};
    rows.forEach((row, index) => {
      if (!row.item) {
        newErrors[`row_${index}`] =
          `Please select Raw Material for row ${index + 1}`;
      }
      // if (!row.consumptionQuantity) {
      //   newErrors[`row_${index}_qty`] =
      //     `Please enter consumption quantity for row ${index + 1}`;
      // }
      // if (row.consumptionQuantity && parseFloat(row.consumptionQuantity) <= 0) {
      //   newErrors[`row_${index}_qty`] =
      //     `Consumption quantity must be greater than 0`;
      // }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Prepare payload for API
  const preparePayload = () => {
    const createdBy = getEmployeeIdValue(bomForm.createdBy) || (loggedInUserId ? String(loggedInUserId) : null);
    const modifiedBy = isEditMode
      ? loggedInUserId
        ? String(loggedInUserId)
        : getEmployeeIdValue(bomForm.modifiedBy) || null
      : null;

    return {
      bom: bomForm.bom,
      item: bomForm.item.value,
      colour: getColourValue(bomForm.colour),
      version: bomForm.version || "v1.0",
      description: bomForm.description || "",
      createdBy,
      modifiedBy,
      CREATEDTIME: bomForm.CREATEDTIME || new Date().toISOString(),
      MODIFIEDTIME: bomForm.MODIFIEDTIME || new Date().toISOString(),
      bomItems: [
        ...rows.map((row) => ({
          ROWID: row.ROWID || null,
          productId: row.item.value,
          uom: row.uom || row.item?.unit || "",
          consumptionQuantity: parseFloat(row.consumptionQuantity),
          availableQuantity: parseInt(row.availableQuantity) || 0,

          isDelete: false
        })),

        ...deletedItems.map((item) => ({
          ROWID: item.ROWID,
          isDelete: true
        }))
      ]
    };
  };
  const handleCreate = async () => {
    if (!validateForm()) {
      toast({
        title: "Validation Error",
        description: "Please fill all required fields",
        status: "error",
        duration: 5000,
      });
      return;
    }

    const payload = preparePayload();
    setIsSubmitting(true);

    try {
      const response = await addBom(payload);
      console.log("Create response:", response);

      if (
        response.data?.success ||
        response.status === 200 ||
        response.status === 201
      ) {
        toast({
          title: "Success",
          description: "BOM created successfully",
          status: "success",
          duration: 5000,
        });

        navigate("/admin/inventory/bom-list");
      } else {
        throw new Error(response.data?.message || "Failed to create BOM");
      }
    } catch (error) {
      console.error("Error creating BOM:", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.message ||
          error.message ||
          "Failed to create BOM",
        status: "error",
        duration: 5000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle update function
  const handleUpdate = async () => {
    if (!validateForm()) {
      toast({
        title: "Validation Error",
        description: "Please fill all required fields",
        status: "error",
        duration: 5000,
      });
      return;
    }

    const payload = preparePayload();
    const updateId = bomId;

    if (!updateId || updateId === "bom-form") {
      toast({
        title: "Error",
        description: "Valid BOM ID not found for update",
        status: "error",
        duration: 5000,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await updateBom(updateId, payload);
      if (
        response.status === 200 ||
        response.status === 201 ||
        response.data?.success
      ) {
        toast({
          title: "Success",
          description: "BOM updated successfully",
          status: "success",
          duration: 5000,
        });

        navigate("/admin/inventory/bom-list");
      } else {
        throw new Error(response.data?.message || "Failed to update BOM");
      }
    } catch (error) {
      console.error("Error updating BOM:", error);
      toast({
        title: "Error",
        description:
          error.response?.data?.message ||
          error.message ||
          "Failed to update BOM",
        status: "error",
        duration: 5000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = () => {
    if (isEditMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  if (loading || inventoryStatus === "pending" || fetchingBom) {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="#011638" thickness="4px" />
      </Center>
    );
  }

  // Show error state
  if (inventoryStatus === "rejected" || inventoryError) {
    return (
      <Center h="100vh">
        <Alert status="error" width="500px" borderRadius="md">
          <AlertIcon />
          <Box flex="1">
            <Heading size="sm" mb={2}>
              Failed to load products
            </Heading>
            <p>{inventoryError || "Could not fetch product list"}</p>
            <Button
              size="sm"
              colorScheme="blue"
              mt={3}
              onClick={() => {
                setLoading(true);
                dispatch(getProduct({ limit: 100 }));
              }}
            >
              Retry
            </Button>
          </Box>
        </Alert>
      </Center>
    );
  }

  return (
    <Box className="h-[93vh] flex flex-col mb-20 overflow-y-auto">
      {/* <Box className="sticky top-0 z-10 bg-white">
        <FormHeader heading={isEditMode ? "Edit BOM" : "Create BOM"} />
      </Box> */}

      <Box className="sticky top-0 z-20 bg-white">
        <FormHeader
          heading="BOM"
          isUpdateMode={isEditMode}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      </Box>

      <Box
        bg="white"
        shadow="md"
        rounded="lg"
        mx={6}
        p={8}
        my={3}
        borderWidth="1px"
      >
        <Heading size="md" mb={4}>
          BOM Information
        </Heading>

        <Grid
          templateColumns={{
            base: "1fr",
            sm: "1fr",
            md: "repeat(3, 1fr)",
          }}
          gap={spacing}
          mb={spacing}
        >
          {/* <FormControl>
            <FormLabel>BOM</FormLabel>
            <Input
              type="text"
              placeholder="Enter BOM (e.g., Del-001)"
              value={bomForm.bom}
              onChange={(e) => handleBomFormChange("bom", e.target.value)}
            />
          </FormControl> */}

          <FormControl isRequired isInvalid={!!errors.item}>
            <FormLabel>Finished Good Item</FormLabel>
            <Select
              options={finishedGoodsOptions}
              value={bomForm.item}
              onChange={(option) => handleBomFormChange("item", option)}
              placeholder={
                finishedGoodsOptions.length === 0
                  ? "No Finished Goods available"
                  : "Select Finished Good"
              }
              isClearable
              isDisabled={finishedGoodsOptions.length === 0}
              styles={{
                control: (base) => ({
                  ...base,
                  cursor: "pointer",
                }),
                option: (base) => ({
                  ...base,
                  cursor: "pointer",
                }),
              }}
            />
            {errors.item && (
              <Box color="red.500" fontSize="sm" mt={1}>
                {errors.item}
              </Box>
            )}
            {finishedGoodsOptions.length === 0 && (
              <Box color="orange.500" fontSize="sm" mt={1}>
                No Finished Goods found in inventory
              </Box>
            )}
          </FormControl>
          <FormControl>
            <FormLabel>Colour</FormLabel>
            <Select
              options={colourOptions}
              value={bomForm.colour}
              onChange={(option) => handleBomFormChange("colour", option)}
              placeholder={
                colourOptions.length === 0
                  ? "No colours available"
                  : "Select Colour"
              }
              isClearable
              isDisabled={colourOptions.length === 0}
              styles={{
                control: (base) => ({
                  ...base,
                  cursor: "pointer",
                }),
                option: (base) => ({
                  ...base,
                  cursor: "pointer",
                }),
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Version</FormLabel>
            <Input
              type="text"
              placeholder="Enter Version (e.g., v1.2)"
              value={bomForm.version}
              onChange={(e) => handleBomFormChange("version", e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="createdBy">Created By</FormLabel>
            <AsyncPaginate
              value={selectedCreatedByOption}
              loadOptions={async (search) => ({
                options: createdByOptions.filter((option) =>
                  option.label.toLowerCase().includes(search?.toLowerCase() || "")
                ),
              })}
              onChange={(selected) =>
                setBomForm((prev) => ({
                  ...prev,
                  createdBy: selected ? String(selected.value) : null,
                }))
              }
              isDisabled={true}
              placeholder="Created By"
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="modifiedBy">Modified By</FormLabel>
            <AsyncPaginate
              value={selectedModifiedByOption}
              loadOptions={async (search) => ({
                options: createdByOptions.filter((option) =>
                  option.label.toLowerCase().includes(search?.toLowerCase() || "")
                ),
              })}
              onChange={(selected) =>
                setBomForm((prev) => ({
                  ...prev,
                  modifiedBy: selected ? String(selected.value) : null,
                }))
              }
              isDisabled={true}
              placeholder={isEditMode ? "Modified By" : "-"}
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="CREATEDTIME">Created Time</FormLabel>
            <Input
              type="text"
              name="CREATEDTIME"
              value={formatDateTime(bomForm.CREATEDTIME)}
              isReadOnly
              isDisabled
            />
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="MODIFIEDTIME">Modified Time</FormLabel>
            <Input
              type="text"
              name="MODIFIEDTIME"
              value={formatDateTime(bomForm.MODIFIEDTIME)}
              isReadOnly
              isDisabled
            />
          </FormControl>

          <FormControl gridColumn="span 3">
            <FormLabel>Description</FormLabel>
            <Textarea
              placeholder="Enter BOM description"
              value={bomForm.description}
              onChange={(e) =>
                handleBomFormChange("description", e.target.value)
              }
              rows={2}
            />
          </FormControl>
        </Grid>
      </Box>

      {/* Raw Materials Table Section */}
      <Box
        className="card"
        p={6}
        borderWidth="1px"
        borderRadius="lg"
        boxShadow="sm"
        bg="white"
        mb={20}
        mx={6}
      >
        <Heading as="h3" size="md" mb={4}>
          BOM Items (Raw Materials)
        </Heading>

        <Flex gap={4} mb={4}>
          <div className="w-full">
            <Box
              overflow="auto"
              maxHeight="450px"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="xl"
              bg="white"
              boxShadow="sm"
              sx={{
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#CBD5E1",
                  borderRadius: "8px",
                },
              }}
            >
              <table className="w-full border-collapse">
                <thead
                  className="sticky top-0 z-10"
                  style={{
                    background:
                      "linear-gradient(to right, #f8fafc, #f1f5f9)",
                  }}
                >
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 w-16">
                      #
                    </th>

                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 w-24">
                      Raw Material
                    </th>

                    <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700 w-44">
                      Image
                    </th>

                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 w-36">
                      UOM
                    </th>

                    <th className="px-4 py-3 text-center text-sm font-semibold text-gray-700 w-20">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {rows.map((row, index) => (
                    <tr
                      key={row.id}
                      className="border-t border-gray-100 hover:bg-blue-50/40 transition-colors"
                    >
                      {/* S.No */}
                      <td className="px-4 py-3 font-medium text-gray-600">
                        {index + 1}
                      </td>

                      {/* Material */}
                      <td className="px-4 py-3 min-w-[400px]">
                        <Select
                          menuPortalTarget={document.body}
                          options={rawMaterialOptions}
                          value={row.item}
                          onChange={(option) =>
                            handleItemChange(option, row.id)
                          }
                          placeholder={
                            rawMaterialOptions.length === 0
                              ? "No Raw Materials"
                              : "Select Raw Material"
                          }
                          isClearable
                          isDisabled={rawMaterialOptions.length === 0}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            control: (base, state) => ({
                              ...base,
                              minHeight: "42px",
                              borderRadius: "10px",
                              borderColor: state.isFocused
                                ? "#3b82f6"
                                : "#e2e8f0",
                              boxShadow: "none",
                            }),
                          }}
                        />

                        {errors[`row_${index}`] && (
                          <Box color="red.500" fontSize="sm" mt={1}>
                            {errors[`row_${index}`]}
                          </Box>
                        )}
                      </td>

                      {/* Image */}
                      <td className="px-4 py-3">
                        {row.item?.imageUrl ? (
                          <img
                            src={encodeURI(row.item.imageUrl)}
                            alt={row.item?.label || ""}
                            className="h-16 w-16 rounded-lg border object-cover mx-auto"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://via.placeholder.com/150?text=No+Image";
                            }}
                          />
                        ) : (
                          <div className="h-16 w-16 rounded-lg border bg-gray-100 flex items-center justify-center text-xs text-gray-500 mx-auto">
                            No Image
                          </div>
                        )}
                      </td>

                      {/* UOM */}
                      <td className="px-4 py-3">
                        <Input
                          type="text"
                          value={row.item?.unit || "pcs"}
                          onChange={(e) =>
                            handleUOMChange(row.id, e.target.value)
                          }
                          size="sm"
                          bg="white"
                          borderRadius="md"
                        />
                      </td>

                      {/* Delete */}
                      <td className="px-4 py-3 text-center">
                        <button
                          onClick={() => deleteRow(row.id)}
                          disabled={rows.length === 1}
                          className={`
                    p-2 rounded-lg transition-all
                    ${rows.length === 1
                              ? "opacity-40 cursor-not-allowed"
                              : "text-red-500 hover:bg-red-50 hover:text-red-600"
                            }
                  `}
                        >
                          <Trash2 size={18} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>

            <div className="mt-4 flex justify-start">
              <button
                type="button"
                onClick={addRow}
                disabled={rawMaterialOptions.length === 0}
                className="bg-[#011638] text-white px-3 py-2 rounded-lg font-medium shadow-sm transition-all disabled:opacity-50"
              >
                + Add BOM Item
              </button>
            </div>
          </div>
        </Flex>
      </Box>
    </Box>
  );
}